var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.clipPolygon,
          expression: "clipPolygon"
        }
      ],
      staticClass: "com"
    },
    [
      _c("div", { staticClass: "sm-function-module-content" }, [
        _c("div", { staticClass: "sm-function-module-sub-section" }, [
          _c(
            "label",
            { staticClass: "sm-function-module-sub-section-caption" },
            [_vm._v("裁剪模式:")]
          ),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.ClipModelSelected,
                  expression: "ClipModelSelected"
                }
              ],
              staticClass: "sm-select",
              staticStyle: { width: "100%" },
              attrs: { id: "" },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.ClipModelSelected = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            _vm._l(_vm.ClipModels, function(Options) {
              return _c(
                "option",
                { key: Options.id, domProps: { value: Options.id } },
                [_vm._v(_vm._s(Options.name))]
              )
            }),
            0
          )
        ]),
        _c("div", { staticClass: "boxchild" }, [
          _c(
            "button",
            {
              staticClass: "tbtn tbn1",
              attrs: { type: "button" },
              on: { click: _vm.clipPolygonStart }
            },
            [_vm._v(" 裁剪 ")]
          ),
          _c(
            "button",
            {
              staticClass: "tbtn",
              attrs: { type: "button" },
              on: { click: _vm.clearClipPolygon }
            },
            [_vm._v(" 清除 ")]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }